{
  "app": {
    "name": "ForumOne"
  },
  "actions": {
    "save": "Guardar",
    "update": "Actualizar",
    "cancel": "Cancelar",
    "refresh": "Actualizar",
    "previous": "Anterior",
    "next": "Siguiente",
    "markAllRead": "Marcar todo como leído",
    "viewDetails": "Ver detalles",
    "viewAll": "Ver todas las notificaciones",
    "tryAgain": "Intentar de nuevo",
    "approve": "Aprobar",
    "decline": "Rechazar",
    "search": "Buscar…",
    "signOut": "Cerrar sesión",
    "help": "Ayuda",
    "helpSupport": "Ayuda y soporte",
    "view": "Ver",
    "edit": "Editar",
    "delete": "Eliminar"
  },
  "labels": {
    "yes": "Sí",
    "no": "No",
    "notAvailable": "N/D"
  },
  "nav": {
    "dashboard": "Panel",
    "appointments": "Citas",
    "slotRequests": "Solicitudes de horario",
    "customers": "Clientes",
    "providers": "Proveedores de servicio",
    "services": "Servicios",
    "finance": "Finanzas",
    "helpSupport": "Ayuda y soporte",
    "adCampaigns": "Campañas publicitarias",
    "businesses": "Negocios e instituciones",
    "settings": "Configuración",
    "tutorialGuide": "Guía tutorial",
    "disabledNoBusiness": "Cree primero un negocio o institución",
    "disabledPendingApproval": "Disponible cuando su negocio sea aprobado"
  },
  "adminNav": {
    "dashboard": "Panel",
    "businesses": "Negocios e instituciones",
    "services": "Servicios",
    "providers": "Proveedores de servicio",
    "adCampaigns": "Campañas publicitarias",
    "pendingAdCampaigns": "Campañas pendientes",
    "appointments": "Citas",
    "customers": "Clientes",
    "pendingApprovals": "Aprobaciones pendientes",
    "issueReports": "Ayuda y soporte",
    "admins": "Administradores del sistema",
    "messaging": "Mensajes",
    "transactions": "Transacciones",
    "payouts": "Solicitudes de pago",
    "adPlans": "Planes publicitarios",
    "businessPlans": "Planes de negocio",
    "industries": "Industrias",
    "settings": "Configuración",
    "adminHome": "Administración"
  },
  "breadcrumbs": {
    "dashboard": "Panel",
    "appointments": "Citas",
    "slotRequests": "Solicitudes de horario",
    "customers": "Clientes",
    "services": "Servicios",
    "providers": "Proveedores de servicio",
    "finance": "Finanzas",
    "support": "Ayuda y soporte",
    "adCampaigns": "Campañas publicitarias",
    "business": "Negocios e instituciones",
    "settings": "Configuración",
    "profile": "Perfil",
    "password": "Contraseña",
    "appearance": "Apariencia",
    "language": "Idioma",
    "notifications": "Notificaciones",
    "create": "Crear",
    "edit": "Editar",
    "import": "Importar",
    "details": "Detalles",
    "businesses": "Negocios e instituciones",
    "pendingApprovals": "Aprobaciones pendientes",
    "pendingAdCampaigns": "Campañas pendientes",
    "admins": "Administradores del sistema",
    "messaging": "Mensajes",
    "messages": "Mensajes",
    "transactions": "Transacciones",
    "payouts": "Solicitudes de pago",
    "adPlans": "Planes publicitarios",
    "industries": "Industrias"
  },
  "errors": {
    "generic": "Ocurrió un error",
    "required": "Obligatorio"
  },
  "commandPalette": {
    "searchPlaceholder": "Buscar páginas y acciones…",
    "empty": "No se encontraron resultados.",
    "groups": {
      "navigation": "Navegación",
      "actions": "Acciones"
    },
    "actions": {
      "createService": "Crear servicio",
      "createProvider": "Crear proveedor",
      "createCampaign": "Crear campaña publicitaria"
    },
    "keywords": {
      "newService": "nuevo servicio",
      "newProvider": "nuevo proveedor"
    },
    "admin": {
      "dashboard": "Panel de administración",
      "businesses": "Negocios",
      "services": "Servicios",
      "providers": "Proveedores",
      "appointments": "Citas",
      "customers": "Clientes",
      "transactions": "Transacciones",
      "payouts": "Pagos",
      "reports": "Ayuda y soporte",
      "messaging": "Mensajería",
      "industries": "Industrias",
      "settings": "Configuración"
    }
  },
  "businessSwitcher": {
    "label": "Negocios e instituciones",
    "businessFallback": "Negocio o institución",
    "noDescription": "Sin descripción",
    "viewAll": "Ver todos los negocios e instituciones",
    "importViaExcel": "Importar vía Excel",
    "addBusiness": "Agregar negocio o institución",
    "ariaLabelSwitch": "Cambiar negocio o institución"
  },
  "dataTable": {
    "emptyTitle": "No se encontraron resultados",
    "emptyDescription": "Intente ajustar su búsqueda o criterios de filtro para encontrar lo que busca.",
    "clearFilters": "Limpiar filtros",
    "filterPlaceholder": "Filtrar...",
    "view": "Ver",
    "rowsSelected": "{{selected}} de {{total}} fila(s) seleccionada(s).",
    "showingRows": "Mostrando {{shown}} de {{total}}",
    "rowsPerPage": "Filas por página",
    "goToFirstPage": "Ir a la primera página",
    "goToPreviousPage": "Ir a la página anterior",
    "goToNextPage": "Ir a la página siguiente",
    "goToLastPage": "Ir a la última página",
    "selectAll": "Seleccionar todo",
    "selectAllRows": "Seleccionar todas las filas",
    "selectRow": "Seleccionar fila",
    "toggleColumns": "Mostrar u ocultar columnas"
  },
  "consoleScope": {
    "adminConsole": "Consola de administración",
    "business": "Negocio",
    "switchAriaLabel": "Cambiar plataforma o negocio",
    "platform": "Plataforma",
    "adminDescription": "Superadministrador y herramientas de plataforma",
    "yourBusinesses": "Sus negocios",
    "noBusinesses": "Aún no hay negocios vinculados a esta cuenta.",
    "openDashboard": "Abrir panel del negocio"
  },
  "modals": {
    "featureNotReadyTitle": "¡Función no disponible!",
    "featureNotReadyDescription": "Esta función aún no está lista para su uso,\npor favor vuelva a intentarlo más tarde.",
    "paymentSuccessTitle": "Pago realizado correctamente"
  }
}
